import { IGetterFn } from '@/store/types';
import { IModuleState } from '@/store/digital-asset/asset/types';
import { getStorage } from '@/utils/storage';

// 文件类型对应的扩展名(暂时不限制)
export const getFileExtensions: IGetterFn<IModuleState> = (state) => {
  return state.fileTypes.data.map((item) => {
    const type = item.optionKey;
    let mineTitle: string;
    switch (type) {
      case '1':   // 源文件
        mineTitle = 'SourceCode';
        break;
      case '2':   // 3D模型
        mineTitle = 'Source3D';
        break;
      case '3':   // 2D源文件
        mineTitle = 'Source2D';
        break;
      case '4':   // 原始资料
        mineTitle = 'RawMaterial';
        break;
      case '5':   // 效果展示
        mineTitle = 'FinalEffect';
        break;
      case '6':   // 说明文档或手册
        mineTitle = 'Manual';
        break;
      case '99':  // 其他
      default:
        mineTitle = 'Others';
        break;
    }

    return { optionKey: type, optionValue: item.optionValue, extensions: '', mineTitle };
  });
};

export const getSearchCountList: IGetterFn<IModuleState> = (state) => {
  try {
    const allDefs = state.allDefs.data;
    const userId = JSON.parse(getStorage('userInfo') || '{}').id;
    const rawList = state.searchCount?.[userId] || [];
    return [...rawList]
      .map((item) => {
        const record = allDefs.filter((sub) => sub.id === item.defId)[0];
        return { ...item, defName: record?.name || '' };
      })
      .sort((a, b) => b.count - a.count)
      .filter((item) => !!item.defName)
      .slice(0, 3);
  } catch (e) {
    return [];
  }
};
